export const environment = {
  production: false,
  msal: {
    clientId: '24b19b03-fb53-470c-93ed-13d1ae299b85',
    redirectUrl: 'https://firmenstammdaten.persona-stg123.de/',
    authority:
      'https://login.microsoftonline.com/1c2b8ed7-dafe-4820-ab1e-23ce67c5326e'
  },
  requiredScopes: ['api://stg-firmenstammdaten-bol/.default'],
  apiHost: 'https://apim-tst.api.persona.de',
  apiBaseUrl: 'stg-firmenstammdaten-bol/v1/api/rest/v1'
};
